import { Config } from "../../../api/config";
export var JobCardInvoicesKeys = {
    Paging: "Paging",
    GeneralTabJobCardDetails: "GeneralTabJobCardDetails",
    GeneralTabCustomerDetails: "getCustomerInfo",
    GeneralTabJobVehicleDetails: "GeneralTabJobVehicleDetails",
    GeneralTabInvoiceDetailsParts: "GeneralTabInvoiceDetailsParts",
    GeneralTabInvoiceDetailsLabour: "GeneralTabInvoiceDetailsLabour",
    InvoicedTabPaging: "InvoicedTabPaging",
    ValidateJCInvoice: "validateJCInvoice",
    PaymentTypeListKey: 'paymentTypeList',
    PaymentTermListKey: 'paymentTermList',
    ConfigurationGet: "ConfigurationGet",
    JobCardInvoiceUpsert: "JobCardInvoiceUpsert",
    ViewInvoiceDetails: 'viewInvoiceDetails',
    installbaseData: 'insallbase',
    CustomerInfo: 'customerInfo',
    DelayReasonListKeys: 'delayReasonList',
    PostingTypeListKeys: 'postingTypeListKey',
    ServiceAdvisorList: 'serviceAdvisorList',
    JCIFilterPagingKey: 'jciFilterPaging',
    JCISearchAPIKeys: 'jciSearchKey',
    ReadyForInvoiceCount: 'readyForInvoiceCount',
    InvoiceCount: 'invoiceCount',
    PaymentMode: 'paymentMode'
};
export var readyForInvoiceAPIKeys = {
    paging: 'ReadyForInvoicePaging'
};
export var JCIAttachmentAPIKeys = {
    create: 'jciAttachmentCreate',
    upload: 'jciAttachmentUpload'
};
export var visibleColumns = {
    DocumentCode: 'Document Number',
    DocumentDate: "Requisition Date",
    CreatedBy: "Created by",
    CreatedOn: "Created date",
    SourceWarehouseName: "Source warehouse",
    DestinationWarehouse: "Destination warehouse",
    ExpectedTransferDate: "Expected Transfer Date",
    StatusName: "Status",
    TotalAmount: "Total Amount"
};
export var JCIPostingTypes = {
    Paid: 'Paid',
    Expenses: 'Expenses',
    Claims: 'Generate Claims'
};
//------------------ Job Card Invoice URL ------------------------------------
export var readyForInvoicePagingAPI = "".concat(Config.baseURL, "JobCard/Paging");
export var jobCardInvoiceGeneralTabJobCardDetailsGet = function (id) {
    return "".concat(Config.baseURL, "JobCard/").concat(id, "/Get");
};
export var jobCardInvoiceGeneralTabCustomerDetailsGet = function (id) {
    return "".concat(Config.baseURL, "Customer/").concat(id, "/Get");
};
export var jobCardInvoiceGeneralTabVehicleDetailsGet = function (id) {
    return "".concat(Config.baseURL, "Installbase/").concat(id, "/GetInstallbaseById");
};
export var jobCardInvoiceGeneralTabInvoiceDetailsPartsGet = function () {
    return "".concat(Config.baseURL, "JobCardDetail/PartsByJCInvoiced");
};
export var jobCardInvoiceGeneralTabInvoiceDetailsLabourGet = function () {
    return "".concat(Config.baseURL, "JobCardDetail/LabourByJCInvoiced");
};
export var invoicedTabPaging = "".concat(Config.baseURL, "JobCardInvoiced/PagingJobCardInvoiced");
export var ValidateJCInvoiceURL = "".concat(Config.baseURL, "JobCardInvoiced/ValidateJCInvoice");
export var paymentTypeListURL = "".concat(Config.baseURL, "PaymentType/List");
export var paymentTermListURL = "".concat(Config.baseURL, "PaymentTerm/List");
export var getViewInvoiceURL = function (id) { return "".concat(Config.baseURL, "JobCardInvoiced/").concat(id, "/Get"); };
export var configurationGet = "".concat(Config.baseURL, "OrganizationModulesItemSetting/GetByChannelId");
// export const jobCardInvoiceUpsert = `${Config.baseURL}JobCardInvoiced/UpsertSettledJC`;
export var jobCardInvoiceUpsert = "".concat(Config.baseURL, "JobCardInvoiced/CreateSettledJCInvoice");
//------------------ Additional Info URL ----------------------------------------
export var JobCardDocumentAttachmentCreateAPI = "".concat(Config.baseURL, "JobCardDocumentAttachment/Create");
export var JobCardDocumentAttachmentUploadAPI = function (id) {
    return "".concat(Config.baseURL, "resource/JobCardDocumentAttachment/").concat(id);
};
//------------------ List URL ---------------------------------------------------------
export var DelayReasonListAPI = "".concat(Config.baseURL, "DelayReason/List");
export var PostingTypeListAPI = "".concat(Config.baseURL, "PostingType/List");
export var ServiceAdvisorListAPI = "".concat(Config.baseURL, "IdentityOrganizationAccessRight/GetServiceAdvisor");
export var PaymentListAPI = "".concat(Config.baseURL, "PaymentMode/List");
export var JCIFilterPagingAPI = "".concat(Config.baseURL, "JobCardInvoiced/PagingJobCardInvoiced");
